module.exports = __webpack_public_path__ + "static/img/ajax1.1e0d693.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/ajax1.jpg
// module id = 66
// module chunks = 9